/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ReactTooltip from 'react-tooltip';
import useConfig from 'app/hooks/useConfig';
import { Ticket, withTicket } from 'app/modules/order';
import { InputNumber, Button, Switch, Modal } from 'app/components';
import infoReduced from '../../../assets/images/infoReduced.jpg';
import storage from 'app/services/storage';

import useSaveSelectionWhileLogin from '../hooks/useSaveSelectionWhileLogin';
import {
  RowButton,
  Page,
  StepWrapper,
  Info,
  WarningInfo,
  WarningInfoTitle,
  WarningInfoDescription,
  PurchaseButtonSection
} from '../styles';
import LineBordered, { BonusCardSection } from './styles';
import { useLogout, useModal } from 'app/hooks';
import { RefundModalContent } from 'app/modules/account/Tickets/styles';


const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,

  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired,

  hasChildTickets: PropTypes.bool.isRequired,
  hasReducedTickets: PropTypes.bool.isRequired,
  hasRegularTickets: PropTypes.bool.isRequired,
  hasPackageRegular: PropTypes.bool.isRequired,
  hasPackageChild: PropTypes.bool.isRequired,
  hasPackageReduced: PropTypes.bool.isRequired,
  hasPackageClub: PropTypes.bool.isRequired,
  maxTickets: PropTypes.number.isRequired,
  maxReservedTickets: PropTypes.number.isRequired,
  maxBonusCardTickets: PropTypes.number.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
  movieCinemaId: PropTypes.string.isRequired,

  saveWizard: PropTypes.func.isRequired,
  notify: PropTypes.func.isRequired,
  sessionData: PropTypes.object.isRequired,

  child: PropTypes.number,
  adult: PropTypes.number,
  reduced: PropTypes.number,
  packageRegular: PropTypes.number,
  packageChild: PropTypes.number,
  packageReduced: PropTypes.number,
  packageClub: PropTypes.number,
  bonusCardBalance: PropTypes.number,
  isBonus: PropTypes.bool,
  clearTicketSession: PropTypes.func.isRequired,
  clearMainSession: PropTypes.func.isRequired,
  clearGiftcardSession: PropTypes.func.isRequired,
  clearPaymentStatus: PropTypes.func.isRequired,
  clearOrder: PropTypes.func.isRequired,
  bookingCount: PropTypes.func.isRequired,
};

const defaultProps = {
  child: 0,
  adult: 0,
  reduced: 0,
  packageRegular: 0,
  packageChild: 0,
  packageReduced: 0,
  packageClub: 0,
  isBonus: false
};

const TicketWrapped = withTicket('session')(Ticket);

const StepTickets = ({
  child,
  adult,
  reduced,
  isBonus,
  packageRegular,
  packageChild,
  packageReduced,
  packageClub,
  saveWizard,
  notify,
  hasChildTickets,
  hasReducedTickets,
  hasRegularTickets,
  hasPackageRegular,
  hasPackageChild,
  hasPackageReduced,
  hasPackageClub,
  maxTickets,
  maxReservedTickets,
  maxBonusCardTickets,
  isLoggedIn,
  movieCinemaId,
  isAboId,
  aboId,
  operaSessionsData,
  bonusCardBalance,
  sessionData,
  history: { push },
  location: { pathname, state },
  clearTicketSession,
  clearMainSession,
  clearGiftcardSession,
  clearPaymentStatus,
  bookingCount,

  clearOrder,
  setConcessionOnServer,
  setConcessionComboOnServer,
}) => {
  const [t, i18n] = useTranslation();
  const lang = i18n.language === 'en-US' ? 'en' : i18n.language === 'de-DE' ? 'de' : i18n.language === 'de' ? 'de' : i18n.language === 'en' && 'en';
  const { country, showingOptions } = useConfig();
  // const location = useLocation();
  const {
    routes,
    wizard: {
      stepTickets: { warnings }
    },
    currencyForCountry
  } = useConfig();
  const { saveSelection } = useSaveSelectionWhileLogin();
  sessionStorage.setItem("movieCinemaId", movieCinemaId)
  const userData = useSelector(state => state.user.user);
  const stateData = useSelector(state => state);
  const sessionBookingCountData = useSelector(state => state?.sessionsTickets?.sessionsBookingCount);
  const locationData = useLocation();
  const isBonusFromSessionPassData = locationData?.state?.isBonusFromSessionPassData;
  const email = locationData?.state?.email;
  const [isShowValidUser, showValidUserModal, hideValidUserModal] = useModal('attention');
  const promotionId = locationData?.state?.promotionId;
  const [maxTicketsBookingCount, setMaxTickets] = useState();
  const [maxReservedTicketsBookingCount, setMaxReservedTickets] = useState();
  const logout = useLogout();
  const history = useHistory();
  useEffect(() => {
    if (sessionBookingCountData?.length === undefined) {

      setMaxTickets(sessionBookingCountData)
      setMaxReservedTickets(sessionBookingCountData)
    }
    else {
      setMaxTickets(maxTickets)
      setMaxReservedTickets(maxReservedTickets)
    }
  }, [sessionBookingCountData]);


  const handleRefund = () => {
    hideValidUserModal();
    logout();
    if (!isLoggedIn) {
      history.push({
        pathname: routes.login.pattern,
        state: { isAboId: isAboId, aboId: aboId, sessionId: sessionData?.session?.id, operaSessionsData: operaSessionsData }
      });
    }
  };
  const handleHomePage = () => {
    hideValidUserModal();
    history.push(routes.movies.pattern);
  };

  useEffect(() => {
    if (isBonusFromSessionPassData === false) {
      bookingCount({ cinemaId: Number(movieCinemaId.split("-")[0]), email: email, promotionId: promotionId });
    }
  }, [])
  const maxTicketRestriction = t('purchase.tickets_amount', {
    // num: maxTickets
    num: maxTicketsBookingCount
  });

  const maxReservationRestriction = t('purchase.tickets_amount', {
    num: maxReservedTicketsBookingCount
    // num: maxReservedTickets
  });

  const maxBonusCardTicketsRestriction = t('purchase.tickets_amount', {
    num: maxBonusCardTickets
  });

  const validateBonuscardBalannce = () => {
    if (isLoggedIn && userData?.giftCardBalance === 0) {
      notify('warning', ['purchase.toasters.bonus_card_restriction']);

      return false;
    }
    return true;
  };

  useEffect(() => {
    const orderId = storage.getOrderId()
    if (orderId) {
      storage.removeOrderId()
    }
  }, [])

  // for ConcessionData
  useEffect(() => {
    setConcessionOnServer(null);
    setConcessionComboOnServer(null);
  }, []);

  useEffect(() => {
    // if (isAboId && emailId !== userLoggedInEmail) {
    if (isAboId && !isLoggedIn) {
      showValidUserModal();
    }
  }, [])
  const setAdult = useCallback(
    val => {
      saveWizard({ adult: val, child, reduced, isBonus, packageRegular, packageReduced, packageChild, packageClub });
    },
    [saveWizard, child, reduced, isBonus, packageRegular, packageReduced, packageChild, packageClub]
  );

  const setChild = useCallback(
    val => {
      saveWizard({ adult, child: val, reduced, packageRegular, packageChild, packageReduced, packageClub });
    },
    [saveWizard, adult, reduced, packageRegular, packageChild, packageReduced, packageClub]
  );

  const setReduced = useCallback(
    val => {
      saveWizard({ adult, child, reduced: val, packageRegular, packageChild, packageReduced, packageClub });
    },
    [saveWizard, adult, child, packageRegular, packageChild, packageReduced, packageClub]
  );
  const setpackageRegular = useCallback(
    val => {
      saveWizard({ adult, child, reduced, packageRegular: val, packageChild, packageReduced, packageClub });
    },
    [saveWizard, adult, child, reduced, packageChild, packageReduced, packageClub]
  );
  const setpackageChild = useCallback(
    val => {
      saveWizard({ adult, child, reduced, packageRegular, packageChild: val, packageReduced, packageClub });
    },
    [saveWizard, adult, child, reduced, packageRegular, packageReduced, packageClub]
  );
  const setpackageReduce = useCallback(
    val => {
      saveWizard({ adult, child, reduced, packageRegular, packageChild, packageReduced: val, packageClub });
    },
    [saveWizard, adult, child, reduced, packageRegular, packageChild, packageClub]
  );
  const setpackageClub = useCallback(
    val => {
      saveWizard({ adult, child, reduced, isBonus, packageRegular, packageChild, packageReduced, packageClub: val });
    },
    [saveWizard, adult, child, reduced, isBonus, packageRegular, packageChild, packageReduced]
  );

  const setIsBonus = useCallback(
    val => {
      if (validateBonuscardBalannce()) {
        saveWizard({ isBonus: val, adult, child, reduced, packageRegular, packageChild, packageReduced });
      }
    },
    [saveWizard, adult, child, reduced, packageRegular, packageChild, packageReduced]
  );

  const next = useCallback(() => {
    const path = generatePath(routes.stepSeats.pattern, { movieCinemaId });
    push({
      pathname: path,
      state: { email: email, isAboId: isAboId, aboId: aboId, operaSessionsData: operaSessionsData }
    });
    saveWizard({ child, adult, reduced, isBonus, packageRegular, packageChild, packageReduced, packageClub });
  }, [adult, child, reduced, movieCinemaId, isBonus, packageRegular, packageChild, packageReduced, packageClub]);

  const onMaxNotify = useCallback(() => {
    notify('warning', [
      'purchase.toasters.order_restriction',
      { amount: isBonus ? maxBonusCardTicketsRestriction : (maxReservedTicketsBookingCount ? maxReservedTicketsBookingCount : maxTicketRestriction) }
    ]);
  }, [isBonus, maxReservedTicketsBookingCount]);

  const onRedirectToLogin = useCallback(() => {
    saveSelection({ child, adult, reduced, packageRegular, packageChild, packageReduced, packageClub });
    push({ pathname: routes.login.pattern, state: { route: pathname } });
  }, [pathname, routes, adult, child, reduced, packageRegular, packageChild, packageReduced, packageClub]);

  const bonusPriceData = sessionData?.userBalance?.cardBalance;
  const bonusPriceSet = bonusPriceData?.toFixed(2).replace('.', ',');

  const ShowBonusCard = useCallback(() => {
    const showFetchBonusMessage = () => {
      return userData?.memberLevelId === 1 ? (
        isBonus && <BonusCardSection>
          <div className="bonuscard-ticket__fetch">
            <h3>{t('common.fetch_bonus_card')}</h3>
          </div>
        </BonusCardSection>
      ) : null;
    };

    return [2, 3].some(item => item === userData?.memberLevelId) ? (
      !isAboId && <BonusCardSection>
        {
          maxBonusCardTickets > 0 ?
            <div className="bonuscard-ticket__header">
              <h3>{t('common.use_bonus_card')}</h3>
              <Switch checked={isBonus} onChange={e => setIsBonus(e.target.checked)} />
            </div>
            :
            <div className="bonuscard-ticket__header">
              <h3 style={{ color: '#de1619' }}>{t('common.max_bonus_card_limit')}</h3>
            </div>
        }
        {isBonus && (
          <div className="bonuscard-ticket__credit">
            <h3>{t('common.credit_bonus_card')}</h3>
            <h3>{currencyForCountry} {bonusPriceSet}</h3>
          </div>
        )}
      </BonusCardSection >
    ) : (
      showFetchBonusMessage()
    );
  }, [isBonus]);

  const showBonusInfo = useCallback(() => {
    return isBonus ? (
      <Info color="#de1619">

        {
          maxBonusCardTickets === 1 ? t('purchase.bonus_card_ticket_info_for_one_ticket') : t('purchase.bonus_card_ticket_info', { how: maxBonusCardTickets })
        }
      </Info>
    ) : null;
  }, [isBonus]);

  useEffect(() => {
    clearTicketSession()
    clearPaymentStatus()
    clearOrder()
    if (!isBonus) {
      clearGiftcardSession()
    }
  }, [])

  return (
    <Page>
      <StepWrapper>
        <TicketWrapped isAboId={isAboId} operaSessionsData={operaSessionsData}>
          {(isLoggedIn) ? (
            // isBonus && ShowBonusCard()
            isBonusFromSessionPassData === false ? "" : ShowBonusCard()
          ) : (
            country === 'rou' ?
              <LineBordered>
                <span className="text-accent" style={{ fontSize: 'medium' }}>{t('purchase.login_row_rou')}</span>
                <Button as="a" isDefault onClick={onRedirectToLogin}>
                  {t('common.login')}
                </Button>
              </LineBordered>
              :
              <LineBordered>
                <span className="text-accent">{t('purchase.login_row')}</span>
                <Button as="a" isDefault onClick={onRedirectToLogin}>
                  {t('common.login')}
                </Button>
              </LineBordered>
          )}

          {(country === 'rou' && !isLoggedIn) ? "" :
            ((hasRegularTickets) &&
              <LineBordered>
                <span>{t('common.adult')}</span>
                <InputNumber
                  value={adult}
                  max={isBonus ? maxBonusCardTickets : maxReservedTicketsBookingCount - child - reduced - packageChild - packageRegular - packageReduced - packageClub}
                  onChange={setAdult}
                  onMax={onMaxNotify}
                />
              </LineBordered>)
          }

          {(country === 'rou' && !isLoggedIn) ? "" :
            showingOptions.childtickets &&
            (!isBonus && (hasChildTickets) && (
              <LineBordered>
                <span>{t('common.child')}</span>
                <InputNumber
                  value={child}
                  max={maxReservedTicketsBookingCount - adult - reduced - packageChild - packageRegular - packageReduced - packageClub}
                  onChange={setChild}
                  onMax={onMaxNotify}
                />
              </LineBordered>)
            )}
          {(country === 'rou' && !isLoggedIn) ? "" :
            (!isBonus && hasPackageRegular && (
              <LineBordered>
                <span>{t('common.packageRegular')}</span>
                <InputNumber
                  value={packageRegular}
                  max={maxReservedTicketsBookingCount - adult - reduced - child - packageChild - packageReduced - packageClub}
                  onChange={setpackageRegular}
                  onMax={onMaxNotify}
                />
              </LineBordered>
            ))}
          {(country === 'rou' && !isLoggedIn) ? "" :
            !isBonus && (hasPackageChild) && (
              <LineBordered>
                <span>{t('common.packageChild')}</span>
                <InputNumber
                  value={packageChild}
                  max={maxReservedTicketsBookingCount - adult - reduced - child - packageRegular - packageReduced - packageClub}
                  onChange={setpackageChild}
                  onMax={onMaxNotify}
                />
              </LineBordered>
            )}
          {(country === 'rou' && !isLoggedIn) ? "" : !isBonus && (hasPackageReduced) && (
            <LineBordered>
              <span>{t('common.packageReduced')}</span>
              <InputNumber
                value={packageReduced}
                max={maxReservedTicketsBookingCount - adult - reduced - child - packageRegular - packageReduced - packageChild}
                onChange={setpackageReduce}
                onMax={onMaxNotify}
              />
            </LineBordered>
          )}
          {(country === 'rou' && !isLoggedIn) ? "" : isBonus && (hasPackageClub) && (
            <LineBordered>
              <span>{t('common.packageClub')}</span>
              <InputNumber
                value={packageClub}
                max={maxReservedTicketsBookingCount - adult - reduced - child - packageRegular - packageChild - packageReduced}
                onChange={setpackageClub}
                onMax={onMaxNotify}
              />
            </LineBordered>
          )}
          {(country === 'rou' && !isLoggedIn) ? "" : !isBonus &&
            (
              (hasReducedTickets)
              // ||
              // (hasReducedTickets && country === 'aut')
            ) && (
              <LineBordered>
                <span>
                  {t('common.reduced')}
                  <img
                    src={infoReduced}
                    data-tip={t('tooltips.reduced')}
                    alt="Info Reduced"
                    style={{ marginLeft: '2rem', position: 'relative', top: '.4rem' }}
                  />
                  <ReactTooltip
                    place="right"
                    type="dark"
                    effect="solid"
                    offset={{ top: -30, left: 10 }}
                    backgroundColor="#2D2D2D"
                  />
                </span>
                <InputNumber
                  value={reduced}
                  max={maxReservedTicketsBookingCount - adult - child - packageChild - packageRegular - packageReduced - packageClub}
                  onChange={setReduced}
                  onMax={onMaxNotify}
                />
              </LineBordered>
            )}

          {!isBonus && isLoggedIn ? (
            <Info>
              {t('purchase.reservation_info', {
                amount: maxReservationRestriction
              })}
            </Info>
          ) : (
            showBonusInfo()
          )}
          {(!isLoggedIn && country === 'rou') ? "" :
            country === "mkd" ?
              <PurchaseButtonSection>
                <span>{t('purchase.purchase_disclaimer')}</span>
                <RowButton>
                  <Button onClick={next} disabled={!(child || adult || reduced || packageRegular || packageChild || packageReduced || packageClub)} isPrimary>
                    {t('purchase.next')}
                  </Button>
                </RowButton>
              </PurchaseButtonSection>
              : <RowButton>
                <Button onClick={next} disabled={!(child || adult || reduced || packageRegular || packageChild || packageReduced || packageClub)} isPrimary>
                  {t('purchase.next')}
                </Button>
              </RowButton>

          }

          {false
            ? warnings[lang].map(warning => (
              <WarningInfo key={warning.title}>
                <WarningInfoTitle dangerouslySetInnerHTML={{ __html: warning.title }} />
                <WarningInfoDescription>{warning.description}</WarningInfoDescription>
              </WarningInfo>
            ))
            : null}
        </TicketWrapped>
      </StepWrapper>
      <Modal
        isOpen={isShowValidUser}
        title={t('purchase.modals.invalid_user_opera_booking.header')}
        close={handleHomePage}
        style={{ pointerEvents: 'none' }}
      >
        <RefundModalContent>
          <div className="refund_modal__modal_message">
            <h3>{t('purchase.modals.invalid_user_opera_booking.label')}</h3>
            <h3>{t('purchase.modals.invalid_user_opera_booking.info')}</h3>
          </div>
          <div className="seasonPass__modal_btns">
            <Button isDefault onClick={handleHomePage} style={{ textAlign: 'center', marginRight: '10px' }}>
              {t('common.cancel')}
            </Button>
            <Button isPrimary onClick={handleRefund}>
              {t('common.login')}
            </Button>
          </div>
        </RefundModalContent>
      </Modal>
    </Page>
  );
};

StepTickets.defaultProps = defaultProps;
StepTickets.propTypes = propTypes;
export default StepTickets;
